import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ConfigTableAction } from "stores/VendorConfigStore/ConfigTableAction";

const mapStateToProps = (state) => {
  return {
    ConfigTableList: state.ConfigTable.ConfigTableList,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getConfigTableAction: ConfigTableAction.getConfigTable,
      UdateConfigCancelAction: ConfigTableAction.UdateConfigCancelAction,
    },
    dispatch
  );

const VendorConfigStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default VendorConfigStore;
